import React from 'react';
import { FormattedMessage } from 'react-intl';

const ConnectCalCTAStrings = {
  titleSynced: (
    <FormattedMessage
      id="hosting.calendar_main.external_calendar_modal_heading_synced"
      defaultMessage="Synced calendar"
    />
  ),
  titleCompleteSync: (
    <FormattedMessage
      id="calendar.connect_cta.title_complete_syncing"
      defaultMessage="Please complete syncing your calendar"
    />
  ),
  titleConnect: (
    <FormattedMessage
      id="hosting.calendar_main.external_calendar_heading"
      defaultMessage="Connect your calendar"
    />
  ),
  bodyConnect: (
    <FormattedMessage
      id="hosting.calendar_main.sync_calendar_getting_started_text"
      defaultMessage="Link your external calendar to show your availability in real time and increase your bookings."
    />
  ),
  bodyCompleteSync: (
    <FormattedMessage
      id="calendar.connect_cta.body_complete_syncing"
      defaultMessage="You're almost done syncing. Please complete the final step to connect your calendar."
    />
  ),
  resyncError: (
    <FormattedMessage
      id="calendar.connect_cta.toast.error_refresh"
      defaultMessage="Unable to refresh calendar. Please try again"
    />
  )
};

export default ConnectCalCTAStrings;
